import _ from 'lodash'
import addiesaas, { Vue } from '../../addiesaas'
import vuestrap from '../../vuestrap'

const EventBus = window.VueEventBus
const DataFilter = window.VueDataFilter

const proxy = { addiesaas, Vue, vuestrap, EventBus, DataFilter }

const RocketEffect = window._$RocketEffect = (window._$RocketEffect || {})

_.forOwn(proxy, (item, key) => {
  if (!_.has(RocketEffect, key)) {
    RocketEffect[key] = item
  }
})

export default RocketEffect
